import { ErrorState, ForbiddenState } from "@/components/states";
import { ApiError, settingsAccessLost } from "@/lib/api";

export function SettingsFailure({ error, retry }: { error: unknown; retry?: () => void }) {
  if (settingsAccessLost(error))
    return (
      <ForbiddenState
        title="Settings are unavailable"
        description="Your access to this project has changed. Reload the project to continue."
      />
    );
  if (!retry)
    return (
      <div role="alert" className="text-sm text-danger">
        <p>
          {error instanceof ApiError
            ? (error.problem?.detail ?? error.message)
            : "The request could not be completed."}
        </p>
        {error instanceof ApiError && error.requestId && (
          <p className="text-muted-foreground">Reference {error.requestId}</p>
        )}
      </div>
    );
  return (
    <ErrorState
      title="Settings could not be saved or loaded"
      description={
        error instanceof ApiError
          ? (error.problem?.detail ?? error.message)
          : "The request could not be completed."
      }
      requestId={error instanceof ApiError ? (error.requestId ?? "unknown") : "unknown"}
      onRetry={retry}
    />
  );
}
